"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = ButtonGroup;

var _react = _interopRequireWildcard(require("react"));

require("../button/button.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ButtonGroup(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'button-group' : _ref$name,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function (v) {} : _ref$onChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '' : _ref$size,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$activeClass = _ref.activeClass,
      activeClass = _ref$activeClass === void 0 ? 'btn-primary active' : _ref$activeClass,
      _ref$inactiveClass = _ref.inactiveClass,
      inactiveClass = _ref$inactiveClass === void 0 ? 'btn-light' : _ref$inactiveClass;

  // use internal state to enable use as both a controlled/uncontrolled component
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      _value = _useState2[0],
      _setValue = _useState2[1];

  (0, _react.useEffect)(function () {
    return _setValue(value);
  }, [value, options]);

  var handleChange = function handleChange(value) {
    _setValue(value);

    onChange && onChange(value);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-group",
    role: "group",
    "data-testid": "ButtonGroup"
  }, options.map(function (option, index) {
    return /*#__PURE__*/_react.default.createElement("label", {
      key: "buttongroup-label-".concat(option.value),
      "data-testid": "buttongroup-label-".concat(option.value),
      className: ['btn', 'c-pointer', disabled ? 'disabled' : '', ['lg', 'sm'].includes(size) ? "btn-".concat(size) : "", option.value === _value ? activeClass : inactiveClass].join(' ')
    }, /*#__PURE__*/_react.default.createElement("input", {
      key: "buttongroup-input-".concat(option.value),
      "data-testid": "buttongroup-input-".concat(option.value),
      disabled: disabled,
      className: "sr-only",
      type: "radio",
      name: name,
      value: option.value,
      checked: option.value === _value,
      onChange: function onChange(_) {
        return handleChange(option.value);
      }
    }), option.label);
  }));
}